import { RootState } from '..';

export const getCurrentUserId = (state: RootState) => state.auth.user?.uid;

export const getCurrentUserIsAnonymous = (state: RootState) =>
  state.auth.user?.isAnonymous;

export const getCurrentUserIdIfNonAnonymous = (state: RootState) =>
  getCurrentUserIsAnonymous(state) ? undefined : getCurrentUserId(state);
